export { default as SerpIntermediaryReplaceSlot } from './SerpIntermediaryReplaceSlot';
